export type LoadedFile = [name: string, file: string | ArrayBuffer | null | undefined];

export async function loadFiles(files: File[]) {
  return Promise.all(
    files?.map(
      (file) =>
        new Promise<LoadedFile>((resolve, reject) => {
          try {
            const fileReader = new FileReader();

            fileReader.onload = async (e) => {
              const arrayBuffer = e.target?.result;

              resolve([file.name, arrayBuffer]);
            };

            fileReader.onerror = (error) => {
              console.error('Error reading file:', error);
            };

            fileReader.readAsArrayBuffer(file);
          } catch (error) {
            reject(error);
          }
        }),
    ) ?? [],
  );
}
